// cSpell: ignore Whatshot Autorenew Octagram
import * as tylerIcons from "@tylertech/tyler-icons";

import { IconRegistry } from "@tylertech/forge";
import {tylIconLightbulb, tylIconLightbulbOn} from "@tylertech/tyler-icons";

IconRegistry.define([
    tylerIcons.tylIconAccessTime,
    tylerIcons.tylIconAdd,
    tylerIcons.tylIconMenu,
    tylerIcons.tylIconReceipt,
    tylerIcons.tylIconList,
    tylerIcons.tylIconEventNote,
    tylerIcons.tylIconPlaylistAddCheck,
    tylerIcons.tylIconAttachFile,
    tylerIcons.tylIconDelete,
    tylerIcons.tylIconCompareArrows,
    tylerIcons.tylIconShuffle,
    tylerIcons.tylIconDeleteSweep,
    tylerIcons.tylIconPlaylistAdd,
    tylerIcons.tylIconWrapText,
    tylerIcons.tylIconAccountBalanceWallet,
    tylerIcons.tylIconEdit,
    tylerIcons.tylIconArchive,
    tylerIcons.tylIconPrint,
    tylerIcons.tylIconPublish,
    tylerIcons.tylIconCollectionsBookmark,
    tylerIcons.tylIconHelp,
    tylerIcons.tylIconHelpOutline,
    tylerIcons.tylIconChat,
    tylerIcons.tylIconSearch,
    tylerIcons.tylIconPeople,
    tylerIcons.tylIconApps,
    tylerIcons.tylIconArrowBack,
    tylerIcons.tylIconArrowForward,
    tylerIcons.tylIconMonetizationOn,
    tylerIcons.tylIconCreditCard,
    tylerIcons.tylIconAttachment,
    tylerIcons.tylIconDescription,
    tylerIcons.tylIconInsertChartOutlined,
    tylerIcons.tylIconAssignmentInd,
    tylerIcons.tylIconInventory,
    tylerIcons.tylIconListAlt,
    tylerIcons.tylIconFolderSpecial,
    tylerIcons.tylIconMoveToInbox,
    tylerIcons.tylIconAssignment,
    tylerIcons.tylIconStoreMallDirectory,
    tylerIcons.tylIconSimCardAlert,
    tylerIcons.tylIconErrorOutline,
    tylerIcons.tylIconReceiptLong,
    tylerIcons.tylIconAddBox,
    tylerIcons.tylIconSwapVert,
    tylerIcons.tylIconRestorePage,
    tylerIcons.tylIconDone,
    tylerIcons.tylIconBuild,
    tylerIcons.tylIconAttachMoney,
    tylerIcons.tylIconPostAdd,
    tylerIcons.tylIconWatchLater,
    tylerIcons.tylIconFormatListNumbered,
    tylerIcons.tylIconNoteAdd,
    tylerIcons.tylIconOpenInNew,
    tylerIcons.tylIconSettings,
    tylerIcons.tylIconCheckCircle,
    tylerIcons.tylIconLens,
    tylerIcons.tylIconHowToReg,
    tylerIcons.tylIconBlock,
    tylerIcons.tylIconDoneAll,
    tylerIcons.tylIconCheck,
    tylerIcons.tylIconBugReport,
    tylerIcons.tylIconDeleteForever,
    tylerIcons.tylIconTimer,
    tylerIcons.tylIconWarning,
    tylerIcons.tylIconLock,
    tylerIcons.tylIconContacts,
    tylerIcons.tylIconAssignmentTurnedIn,
    tylerIcons.tylIconAccountBalance,
    tylerIcons.tylIconMoneyOff,
    tylerIcons.tylIconForward30,
    tylerIcons.tylIconFlightLand,
    tylerIcons.tylIconFlightTakeoff,
    tylerIcons.tylIconPermContactCalendar,
    tylerIcons.tylIconFitnessCenter,
    tylerIcons.tylIconSchedule,
    tylerIcons.tylIconDeveloperBoard,
    tylerIcons.tylIconAccountCircle,
    tylerIcons.tylIconStar,
    tylerIcons.tylIconWhatshot,
    tylerIcons.tylIconDiscFull,
    tylerIcons.tylIconPerson,
    tylerIcons.tylIconCancel,
    tylerIcons.tylIconAutorenew,
    tylerIcons.tylIconRestore,
    tylerIcons.tylIconReport,
    tylerIcons.tylIconPersonOutline,
    tylerIcons.tylIconNotifications,
    tylerIcons.tylIconInfoOutline,
    tylerIcons.tylIconSchool,
    tylerIcons.tylIconGroupWork,
    tylerIcons.tylIconLocalHospital,
    tylerIcons.tylIconTrendingUp,
    tylerIcons.tylIconAddCircle,
    tylerIcons.tylIconRemoveCircle,
    tylerIcons.tylIconError,
    tylerIcons.tylIconNotificationsActive,
    tylerIcons.tylIconNotificationsNone,
    tylerIcons.tylIconToday,
    tylerIcons.tylIconShoppingCart,
    tylerIcons.tylIconFindInPage,
    tylerIcons.tylIconShare,
    tylerIcons.tylIconDraw,
    tylerIcons.tylIconNotInterested,
    tylerIcons.tylIconDragIndicator,
    tylerIcons.tylIconClose,
    tylerIcons.tylIconMoreVert,
    tylerIcons.tylIconMoreHoriz,
    tylerIcons.tylIconBolt,
    tylerIcons.tylIconChatBubbleOutline,
    tylerIcons.tylIconImportExport,
    tylerIcons.tylIconVisibility,
    tylerIcons.tylIconVisibilityOff,
    tylerIcons.tylIconGridView,
    tylerIcons.tylIconSparkles,
    tylerIcons.tylIconKeyboardArrowRight,
    tylerIcons.tylIconKeyboardArrowLeft,
    tylerIcons.tylIconKeyboardArrowDown,
    tylerIcons.tylIconKeyboardArrowUp,
    tylerIcons.tylIconArrowDropDown,
    tylerIcons.tylIconRotateLeft,
    tylerIcons.tylIconReplay,
    tylerIcons.tylIconDoNotDisturb,
    tylerIcons.tylIconLockOpen,
    tylerIcons.tylIconOfflinePin,
    tylerIcons.tylIconMailOutline,
    tylerIcons.tylIconUndo,
    tylerIcons.tylIconPageview,
    tylerIcons.tylIconPlayArrow,
    tylerIcons.tylIconStop,
    tylerIcons.tylIconSearch,
    tylerIcons.tylIconPayment,
    tylerIcons.tylIconOpenInBrowser,
    tylerIcons.tylIconApproval,
    tylerIcons.tylIconDoneOutline,
    tylerIcons.tylIconChevronLeft,
    tylerIcons.tylIconChevronRight,
    tylerIcons.tylIconPieChart,
    tylerIcons.tylIconSync,
    tylerIcons.tylIconSortNumericVariant,
    tylerIcons.tylIconSortAlphabeticalVariant,
    tylerIcons.tylIconContentCopy,
    tylerIcons.tylIconPowerOff,
    tylerIcons.tylIconRefresh,
    tylerIcons.tylIconPhoneIphone,
    tylerIcons.tylIconExpand,
    tylerIcons.tylIconFilterAlt,
    tylerIcons.tylIconCheckBox,
    tylerIcons.tylIconCheckBoxOutlineBlank,
    tylerIcons.tylIconInput,
    tylerIcons.tylIconFilterList,
    tylerIcons.tylIconViewStream,
    tylerIcons.tylIconLastPage,
    tylerIcons.tylIconFirstPage,
    tylerIcons.tylIconArrowUpward,
    tylerIcons.tylIconArrowDownward,
    tylerIcons.tylIconGridOn,
    tylerIcons.tylIconCenterFocusStrong,
    tylerIcons.tylIconUpdate,
    tylerIcons.tylIconHome,
    tylerIcons.tylIconFormatIndentIncrease,
    tylerIcons.tylIconSend,
    tylerIcons.tylIconLibraryBooks,
    tylerIcons.tylIconNaturePeople,
    tylerIcons.tylIconMap,
    tylerIcons.tylIconFormatPaint,
    tylerIcons.tylIconPolicy,
    tylerIcons.tylIconDomain,
    tylerIcons.tylIconImage,
    tylerIcons.tylIconBookmark,
    tylerIcons.tylIconBookmarkBorder,
    tylerIcons.tylIconRadioButtonUnchecked,
    tylerIcons.tylIconRemove,
    tylerIcons.tylIconHistory,
    tylerIcons.tylIconHistoryToggleOff,
    tylerIcons.tylIconFileUpload,
    tylerIcons.tylIconAddShoppingCart,
    tylerIcons.tylIconCheckCircleOutline,
    tylerIcons.tylIconCrop,
    tylerIcons.tylIconFileDownload,
    tylerIcons.tylIconAccount,
    tylerIcons.tylIconBookmarkOff,
    tylerIcons.tylIconSortAlt,
    tylerIcons.tylIconSortAscending,
    tylerIcons.tylIconSortDescending,
    tylerIcons.tylIconCalendarClockOutline,
    tylerIcons.tylIconClipboardClockOutline,
    tylerIcons.tylIconCashCheck,
    tylerIcons.tylIconTransfer,
    tylerIcons.tylIconFileImport,
    tylerIcons.tylIconSwapHorizontalCircleOutline,
    tylerIcons.tylIconAccountCash,
    tylerIcons.tylIconBankPlus,
    tylerIcons.tylIconBriefcaseClock,
    tylerIcons.tylIconCreditCardClock,
    tylerIcons.tylIconBusSchool,
    tylerIcons.tylIconFormatListChecks,
    tylerIcons.tylIconCheckbook,
    tylerIcons.tylIconOfficeBuilding,
    tylerIcons.tylIconFilePercentOutline,
    tylerIcons.tylIconClipboardTextOutline,
    tylerIcons.tylIconChevronDown,
    tylerIcons.tylIconChevronUp,
    tylerIcons.tylIconChevronDoubleDown,
    tylerIcons.tylIconChevronDoubleUp,
    tylerIcons.tylIconSignalCellular2,
    tylerIcons.tylIconCalendarClock,
    tylerIcons.tylIconAlertOctagram,
    tylerIcons.tylIconPrinterCheck,
    tylerIcons.tylIconTruck,
    tylerIcons.tylIconDoNotDisturb,
    tylerIcons.tylIconWater,
    tylerIcons.tylIconPipe,
    tylerIcons.tylIconAlertOutline,
    tylerIcons.tylIconPin,
    tylerIcons.tylIconPinOff,
    tylerIcons.tylIconTableSettings,
    tylerIcons.tylIconDownload,
    tylerIcons.tylIconUpload,
    tylerIcons.tylIconBullhorn,
    tylerIcons.tylIconEyeOutline,
    tylerIcons.tylIconFilterRemove,
    tylerIcons.tylIconPercent,
    tylerIcons.tylIconFormSelect,
    tylerIcons.tylIconMathCompass,
    tylerIcons.tylIconChevronDoubleRight,
    tylerIcons.tylIconChevronDoubleLeft,
    tylerIcons.tylIconHelpBox,
    tylerIcons.tylIconAlertCircleOutline,
    tylerIcons.tylIconSchool,
    tylerIcons.tylIconProgressCheck,
    tylerIcons.tylIconArrowCollapseVertical,
    tylerIcons.tylIconCheckboxMultipleBlankOutline,
    tylerIcons.tylIconCheckboxMultipleMarked,
    tylerIcons.tylIconFileEyeOutline,
    tylerIcons.tylIconPlayOutline,
    tylerIcons.tylIconStopCircleOutline,
    tylerIcons.tylIconCalculator,
    tylerIcons.tylIconClockOutline,
    tylerIcons.tylIconInboxArrowUp,
    tylerIcons.tylIconBookOpenVariant,
    tylerIcons.tylIconJira,
    tylerIcons.tylIconCardAccountDetailsOutline,
    tylerIcons.tylIconVote,
    tylerIcons.tylIconAccountMultiple,
    tylerIcons.tylIconPackageVariant,
    tylerIcons.tylIconInboxArrowDown,
    tylerIcons.tylIconFormatListCheckbox,
    tylerIcons.tylIconTools,
    tylerIcons.tylIconWrench,
    tylerIcons.tylIconPinOutline,
    tylerIcons.tylIconPinOffOutline,
    tylerIcons.tylIconNoteTextOutline,
    tylerIcons.tylIconVectorLink,
    tylerIcons.tylIconNote,
    tylerIcons.tylIconWizardHat,
    tylerIcons.tylIconCalendarBlank,
    tylerIcons.tylIconCalendarPlus,
    tylerIcons.tylIconCalendarRemoveOutline,
    tylerIcons.tylIconAccountPlus,
    tylerIcons.tylIconTextBoxCheckOutline,
    tylerIcons.tylIconAccountRemove,
    tylerIcons.tylIconAccessPoint,
    tylerIcons.tylIconCircle,
    tylerIcons.tylIconCircleHalfFull,
    tylerIcons.tylIconCircleOutline,
    tylerIcons.tylIconEye,
    tylerIcons.tylIconHammer,
    tylerIcons.tylIconChartBar,
    tylerIcons.tylIconTooltipText,
    tylerIcons.tylIconMenuOpen,
    tylerIcons.tylIconRepeat,
    tylerIcons.tylIconExport,
    tylerIcons.tylIconImport,
    tylerIcons.tylIconTylerCoachAccountInfo,
    tylerIcons.tylIconTylerTalkingTLogo,
    tylerIcons.tylIconLightbulbOn,
    tylerIcons.tylIconArrowUpDown
]);
